import { useEffect } from 'react';

const defaultSEO = {
  title: 'Frequency Forest 2026',
  description: 'Join us for 3 days of world-class electronic music and carnival experience at Maitland Showgrounds, NSW. September 25-27, 2026.',
  image: '/images/artwork/hero-cover.jpg',
};

const setMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
};

export default function SEO({ title, description, image, url, type = 'website' }) {
  useEffect(() => {
    const seoTitle = title ? `${title} | Frequency Forest 2026` : defaultSEO.title;
    const seoDescription = description || defaultSEO.description;
    const seoImage = image || defaultSEO.image;
    const seoUrl = url || `${window.location.origin}${window.location.pathname}`;

    document.title = seoTitle;
    setMeta('name', 'description', seoDescription);
    setMeta('property', 'og:title', seoTitle);
    setMeta('property', 'og:description', seoDescription);
    setMeta('property', 'og:image', seoImage);
    setMeta('property', 'og:url', seoUrl);
    setMeta('property', 'og:type', type);
    setMeta('name', 'twitter:title', seoTitle);
    setMeta('name', 'twitter:description', seoDescription);
    setMeta('name', 'twitter:image', seoImage);
  }, [title, description, image, url, type]);

  return null;
}
